// Single-file branding config — rename the app here.
export const APP = {
  name: "NumberSense",
  tagline: "Build durable math understanding, one mastered skill at a time.",
};

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const gradeLabel = (g) => (g === 0 ? "Kindergarten" : `Grade ${g}`);
export const gradeShort = (g) => (g === 0 ? "K" : `Grade ${g}`);
export const GRADE_OPTIONS = [0, 1, 2, 3, 4, 5, 6, 7, 8];
